import React from 'react';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Form from 'components/form';
import Box from '@mui/material/Box';
import TextField from 'components/form/TextInput';
import Button from 'components/Button';
import { sendResetPassword } from 'services/users';
import * as Styled from './styled';
import toast from 'utils/toast';
import { LoginForm } from '../login/styled';
import Typography from '@mui/material/Typography';

const FormItem = Form.FormItem;

class ForgotPassword extends React.Component {
  state = {
    sent: false,
  };
  handleSubmit = (e) => {
    e.preventDefault();
    return this.props.form.validateFields().then((values) => {
      return sendResetPassword(values.email).then(
        () => this.setState({ sent: true }),
        (e) => toast.error(e.message),
      );
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      className,
      style,
      t,
    } = this.props;

    return (
      <Styled.Container className={className} style={style}>
        <Helmet title={t('auth:forgot-password', 'Forgot Password')} />
        <div className="form-container">
          <Box mb={4} className="logo" textAlign="center">
            <img
              src={`/assets/svg/tic-logo-full.svg`}
              alt="logo"
              className="logo"
            />
          </Box>
          <LoginForm>
            <Typography textAlign="center" variant="h2">
              Reset Password
            </Typography>
            <div className="fields">
              <Form>
                {this.state.sent ? (
                  <Box textAlign="center">
                    {t(
                      'auth:forgot-password-mail-sent',
                      'Your password reset is on its way! Please check your email.',
                    )}
                  </Box>
                ) : (
                  <div>
                    <FormItem>
                      {getFieldDecorator('email', {
                        rules: [
                          {
                            required: true,
                            type: 'email',
                            message: t(
                              'auth:email-error',
                              'Please enter a valid email address',
                            ),
                          },
                        ],
                      })(
                        <TextField
                          label={t('auth:email-label')}
                          placeholder={t(
                            'auth:email-placeholder',
                            'Enter Email',
                          )}
                          type="email"
                          fullWidth
                        />,
                      )}
                    </FormItem>
                    <Box mt={1}>
                      <Button
                        fullWidth
                        onClick={this.handleSubmit}
                        sx={{ mb: 1 }}
                      >
                        {t('auth:forgot-submit', 'Get New Password')}
                      </Button>
                      <Button
                        fullWidth
                        component={Link}
                        to="/login"
                        variant="text"
                      >
                        Back
                      </Button>
                    </Box>
                  </div>
                )}
              </Form>
            </div>
          </LoginForm>
        </div>
      </Styled.Container>
    );
  }
}

export default Form.create()(withTranslation('auth')(ForgotPassword));
